import React from 'react';

export default class  Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>PERCEPTIONS AND RIGHTS</div>
                                            <p>Most of us know people with whom it’s easy to get our own way and
                                                others who are, perhaps, less persuadable. Being assertive at
                                                work can help you keep your workload manageable or get the
                                                resources you need for a project.</p>
                                            <p>Assertiveness means standing up for your rights without violating
                                                those of others. </p>
                                            <div className="paraspace"><p>You may be surprised to learn that
                                                your rights include:</p></div>
                                            <ul className="greenbullet-list people-list-pad">
                                                <li>The right to make mistakes</li>
                                                <li>The right to set your own priorities</li>
                                                <li>The right to have your own needs considered</li>
                                                <li>The right to refuse requests</li>
                                                <li>The right to express yourself</li>
                                                <li>The right to judge your own behaviour, thoughts and emotions
                                                    and take responsibility for the consequences.
                                                </li>
                                            </ul>
                                            <p>Obviously other people have the same rights as you, and some will
                                                have authority where you do not. Being assertive does not
                                                include being aggressive or failing to acknowledge others’
                                                rights.</p>
                                            <p>Here are some examples of some common assumptions in the
                                                workplace and how they can sometimes clash with your rights
                                                while you are at work. They are general examples in order to
                                                broaden your thinking on the subject, and as with anything they
                                                could be incorrect if taken to extremes.</p>
                                            <p>However, it is important to think about such examples, because
                                                there are plenty of instances where we might be passing up a
                                                chance to be assertive out of fear of being ‘wrong’. The main
                                                thing to remember is that there is nothing ‘wrong’ about being
                                                confident and acting within your rights at work.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink ilead_v_sport1">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="top" colSpan="2"
                                                        className="green_curve green_curve1">Common assumptions
                                                        and your legitimate rights<a className="superscripttext"
                                                                                     href="further_info.php?course=300"><sup>2</sup></a>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><span className=""><p>People need to take care of themselves. </p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><p>Anyone has the right to ask
                                                        for help or support.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><span className=""><p>Don’t complain or be negative. </p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><p>You’re entitled to be honest
                                                        about the way you feel. </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><span className=""><p>Advice is usually given from experience and for good reasons – you should follow it.</p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><p>While it is wise to receive
                                                        advice, you always retain the right to decide whether to
                                                        act on it or not.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><span className=""><p>You’re just doing your job, don’t expect any thanks.</p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><p>You’re entitled to have your
                                                        contribution and successes acknowledged.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><span className=""><p>This is what everybody does in the sector, you just need to turn a blind eye.</p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><p>You always have the right to
                                                        challenge an action at work that you believe is
                                                        unethical by raising it through the proper
                                                        mechanism. </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><span className=""><p>You need to be sociable, otherwise you’re just being difficult. </p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><p>It’s your right to choose when
                                                        or whether to socialise.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><span className=""><p>You need to be able to justify yourself. </p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen"><p>You do not have to justify
                                                        your feelings and actions to others if you don’t want
                                                        to.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><span className=""><p>You should always help those around you before you help yourself.</p></span>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="darkgreen"><p>While it definitely helps to
                                                        support others,&nbsp;this does not have to be at the
                                                        expense of your own wellbeing.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page1')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page3')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>


                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}